import { deepClone } from 'src/app/helpers/utils';

import { Directive, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { BaseComponent } from '../../core/abstracts/baseComponent';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import { State } from 'src/app/core/store';
import { FBFormSubmissionModel } from '../../models/formBuilderModels';
import { getFBFormSubmission } from '../../core/store/form-builder/form-builder.actions';
import { ActivatedRoute } from '@angular/router';

@Directive()
export class SignDocComponentBase extends BaseComponent implements AfterViewInit, OnDestroy {

  @ViewChild('pdfViewer', { static: false }) pdfViewer;
  public signedFields: string[] = [];
  public finishSignDisabled: boolean;
  public intervalFormattingSignature;
  public stopFormattingSignature: boolean = false;
  public currentUserID;
  public isHRManager;
  public isSigningAsHRManager;
  public optionalFields: string[] = [];
  public url: any;
  public pagesloaded = false;
  public formSubmission: FBFormSubmissionModel = null;
  
  constructor(
    private storeBase: Store<State>
  ) {
    super();
    this.formSubmission = null;
    this.subs.push(
      this.storeBase.select(s => s.profileState.profile).subscribe(p => {
        if (p) {
          this.finishSignDisabled = !!p.user.impersonatedByUserID;
          this.currentUserID = p.userId;
        }
      }),
      this.storeBase.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.isHRManager = permissionIDs && !!permissionIDs.find(p => p === 3060 || p === 3064 || p === 3068);
      }),
      
      this.storeBase.select(s => s.formBuilderState.formSubmission).subscribe(fs => {
        this.formSubmission = fs;
      })

    );
  }

  ngAfterViewInit() {
    if (!this.intervalFormattingSignature) {
      this.intervalFormattingSignature = setInterval(() => {
        this.formatSignatureFields();
      }, 3000);
    }

    this.afterPdfViewerInit();
  }

  ngOnDestroy() {
    this.stopFormattingSignature = true;
    if (this.intervalFormattingSignature) {
      clearTimeout(this.intervalFormattingSignature);
    }
  }

  afterPdfViewerInit() {
    const that = this;
    setTimeout(() => {
      if (!this.url || !this.pdfViewer || !this.pdfViewer.PDFViewerApplication || !this.pdfViewer.PDFViewerApplication.eventBus) {
        if (!this.stopFormattingSignature) {
          this.afterPdfViewerInit();
        }
      } else {
        this.pdfViewer.page = 1;
        this.pdfViewer.PDFViewerApplication.eventBus._dispatchToDOM = true;
        this.pdfViewer.PDFViewerApplication.eventBus.on('pagesloaded', (e) => {
          this.pagesloaded = true;
          this.pdfViewer.page = 1;
          if (document.getElementsByTagName('iframe')[0] && document.getElementsByTagName('iframe')[0].contentDocument
          && document.getElementsByTagName('iframe')[0].contentDocument.getElementById('viewerContainer')){
            document.getElementsByTagName('iframe')[0].contentDocument.getElementById('viewerContainer').scrollTo(0, 0);
          }
          this.formatSignatureFields();
        });
        this.pdfViewer.PDFViewerApplication.eventBus.on('pagechanging', (e) => {
          this.pagesloaded = true;
          this.formatSignatureFields();
        });
        if (document.getElementsByTagName('iframe')[0] && document.getElementsByTagName('iframe')[0].contentDocument
          && document.getElementsByTagName('iframe')[0].contentDocument.getElementById('viewerContainer')){
            document.getElementsByTagName('iframe')[0].contentDocument.getElementById('viewerContainer').scrollTo(0, 0);
          }
        this.formatSignatureFields();
        setTimeout(() => {
          this.formatSignatureFields();
        }, 1000);
      }
    }, 500);

    that.formatSignatureFields();
  }

  formatSignatureFields() {
    
    const that = this;
    if (document.getElementsByTagName('iframe')[0] && document.getElementsByTagName('iframe')[0].contentDocument ) {
      const viewer = document.getElementsByTagName('iframe')[0].contentDocument.getElementById('viewer');
      if (viewer && viewer.querySelectorAll('.page')) {
        const imgs = document.getElementsByTagName('iframe')[0].contentDocument.querySelectorAll('.annotationLayer section img');
        imgs.forEach(img => {
          if (img && img.parentNode) {
            img.parentNode.removeChild(img);
          }
        });

        const freeTextAnnotations =
          document.getElementsByTagName('iframe')[0].contentDocument.querySelectorAll('.annotationLayer section.freeTextAnnotation');
        freeTextAnnotations.forEach(freeTextAnnotation => {
          if (freeTextAnnotation && freeTextAnnotation.parentNode) {
          freeTextAnnotation.parentNode.removeChild(freeTextAnnotation);
          }
        });


        const secondaryToolbarToggle = document.getElementsByTagName('iframe')[0].contentDocument.getElementById('secondaryToolbarToggle');
        if (secondaryToolbarToggle && secondaryToolbarToggle.parentNode){
            secondaryToolbarToggle.parentNode.removeChild(secondaryToolbarToggle);
        }

        const myEles = document.getElementsByTagName('iframe')[0].contentDocument.querySelectorAll('div.popup');
        for (const ele of Array.from(myEles)) {
          if (ele && ele.innerHTML) {
            if (ele.innerHTML.toLowerCase().indexOf('<h1>datesignature') === 0 || ele.innerHTML.toLowerCase().indexOf('<h1>#datesignature#') === 0) {
              if (!this.isSigningAsHRManager ||
                (this.isSigningAsHRManager && ele.innerHTML.toLowerCase().indexOf('#hruser#') >= 0 && this.isHRManager) ) {
                  const divNova = document.getElementsByTagName('iframe')[0].contentDocument.createElement('div');
                  divNova.innerHTML = `<div style='color: rgba(0,0,0,1);
                                      opacity: 1;z-index: 999999;
                                      border: 0px solid black;
                                      margin-top:2px;
                                      text-align: center;
                                      width: 100px;
                                      min-height: 10px;
                                      font-size:10px;
                                      cursor: pointer;'  > ` + moment().format('MM/DD/YYYY') + `
                                      </div>`;
                  ele.parentNode.parentNode.insertBefore(divNova, ele.parentNode.parentNode.firstChild);
                  ele.parentNode.parentNode.removeChild(ele.parentNode);
                }
            }
            if (ele.innerHTML.toLowerCase().indexOf('<h1>signature') === 0 || ele.innerHTML.toLowerCase().indexOf('<h1>initial') === 0
            || ele.innerHTML.toLowerCase().indexOf('<h1>#signature#') === 0 || ele.innerHTML.toLowerCase().indexOf('<h1>#initials#') === 0) {
              const signatureFieldName = ele.innerHTML.split('</h1>')[0].replace('<h1>', '');

              const userID = this.extractUserID(signatureFieldName);
              if (((!userID && signatureFieldName.toLowerCase().indexOf('#hruser#') < 0 && !this.isSigningAsHRManager) || userID === this.currentUserID?.toString())
                || (this.isSigningAsHRManager && signatureFieldName.toLowerCase().indexOf('#hruser#') >= 0 && this.isHRManager)) {

                let isSigned = that.signedFields.indexOf(signatureFieldName) >= 0;
                const isRequired = (ele.innerHTML.toLowerCase().indexOf('optional') < 0) && !(this.optionalFields.indexOf(signatureFieldName) >= 0);

                const divNova = document.getElementsByTagName('iframe')[0].contentDocument.createElement('div');
                divNova.innerHTML = `<div style='color: rgba(0,0,0,1);
                                  opacity: 1;z-index: 999999;
                                  border: 1px solid black;
                                  background-color: `
                  + (isSigned ? 'rgba(66, 245, 66, 1)' : (isRequired ? 'rgba(245, 66, 66,1)' : 'rgba(245, 221, 66,1)')) + `;
                                  text-align: center;
                                  width: ` + ((ele.innerHTML.toLowerCase().indexOf('<h1>signature') === 0 || ele.innerHTML.toLowerCase().indexOf('<h1>#signature#') === 0) ? '100' : '34') + `px;
                                  min-height: 10px;
                                  font-size:10px;
                                  cursor: pointer;'
                                  title='` + (isSigned ? 'signed' : (isRequired ? 'Required Signature' : 'Optional Signature')) + `'
                                  > ` + (isSigned ? 'Signed' : 'Sign') + `
                                  </div>`;
                divNova.onclick = (e) => {
                  (e.target as any).style.backgroundColor =
                    (isSigned ? (isRequired ? 'rgba(245, 66, 66,1)' : 'rgba(245, 221, 66,1)') : 'rgba(66, 245, 66, 1)');
                  (e.target as any).innerHTML = isSigned ? 'Sign' : 'Signed';
                  if (isSigned) {
                    
                    that.signedFields.splice(that.signedFields.indexOf(signatureFieldName), 1);
                  } else {
                    that.signedFields.push(signatureFieldName);
                  }
                  isSigned = !isSigned;
                };
                ele.parentNode.parentNode.insertBefore(divNova, ele.parentNode.parentNode.firstChild);
              }
              ele.parentNode.parentNode.removeChild(ele.parentNode);
            }

            if (this.formSubmission && this.formSubmission.fbFormSignatures && this.formSubmission.fbForm) {
              const contributors = this.formSubmission.fbFormContributor || [];
              const currentContributors = contributors
                .filter(s => s.userID == this.currentUserID)
                .map(m => m.contributorID);
              //if current user is a contributor
              if (currentContributors.some(s => s))
              {
                // for each signature field in this.formSubmission.fbForm which current user can sign
                for (const signatureField of (this.formSubmission.fbForm.formSignatures || []).filter(fs => (ele.innerHTML.indexOf(`<h1>${fs.signatureName}</h1>`) >= 0 || ele.innerHTML.indexOf(`<h1>${fs.signatureName}_date</h1>`) >= 0))) {
                  //signed
                  let signed = this.formSubmission.fbFormSignatures.find(s => s.formSignatureFieldID == signatureField.id && !!s.signedDate);
                  if (signed) {
                    if (ele.innerHTML.toLowerCase().indexOf('_date') > 0) {
                      const divNova = document.getElementsByTagName('iframe')[0].contentDocument.createElement('div');
                      divNova.innerHTML = `<div style='color: rgba(0,0,0,1);
                                      opacity: 1;z-index: 999999;
                                      border: 0px solid black;
                                      margin-top:2px;
                                      text-align: center;
                                      min-height: 10px;
                                      font-size:10px;
                                      width: 100px;
                                      cursor: pointer;'
                                     id='div${signatureField.signatureName.replace(" ", "")}_date'>
                                     ${moment(signed.signedDate).format('MM/DD/YYYY') }
                                      </div>`;
                      if (ele.parentNode.parentNode) {
                        ele.parentNode.parentNode.insertBefore(divNova, ele.parentNode.parentNode.firstChild);
                        ele.parentNode.parentNode.removeChild(ele.parentNode);
                      }
                    }

                    else {
                      const signatureFieldName = signatureField.signatureName;
                      let isSigned = true;
                      const isRequired = false;// (ele.innerHTML.toLowerCase().indexOf('optional') < 0) && !(this.optionalFields.indexOf(signatureFieldName) >= 0);

                      const divNova = document.getElementsByTagName('iframe')[0].contentDocument.createElement('div');
                      divNova.innerHTML = `<div style='color: rgba(0,0,0,1);
                                  opacity: 1;z-index: 999999;
                                  border: 1px solid black;
                                  background-color: `
                        + (isSigned ? 'rgba(66, 245, 66, 1)' : (isRequired ? 'rgba(245, 66, 66,1)' : 'rgba(245, 221, 66,1)')) + `;
                                  text-align: center;
                                  width: ` + ((ele.innerHTML.toLowerCase().indexOf('<h1>signature') === 0 || ele.innerHTML.toLowerCase().indexOf('<h1>#signature#') === 0) ? '100' : '34') + `px;
                                  min-height: 10px;
                                  font-size:10px;
                                  cursor: pointer;'
                                  title='` + (isSigned ? 'signed' : (isRequired ? 'Required Signature' : 'Optional Signature')) + `'
                                  id='div${signatureFieldName.replace(" ", "")}'
                                  > ` + (isSigned ? 'Signed' : 'Sign') + `
                                  </div>`;
                      divNova.onclick = (e) => {
                        (e.target as any).style.backgroundColor =
                          (isSigned ? (isRequired ? 'rgba(245, 66, 66,1)' : 'rgba(245, 221, 66,1)') : 'rgba(66, 245, 66, 1)');
                        (e.target as any).innerHTML = isSigned ? 'Sign' : 'Signed';
                        const target = e.target as HTMLElement;
                        const dateElement = target.id ? document.getElementsByTagName('iframe')[0].contentDocument.getElementById(`${target.id}_date`) : null;

                        if (isSigned) {
                          that.signedFields.splice(that.signedFields.indexOf(signatureFieldName), 1);
                          if (dateElement)
                            dateElement.innerHTML = '';
                        } else {
                          that.signedFields.push(signatureFieldName);
                          if (dateElement)
                            dateElement.innerHTML = moment().format('MM/DD/YYYY');
                        }
                        isSigned = !isSigned;
                      };
                      if (ele.parentNode.parentElement)
                        ele.parentNode.parentNode.insertBefore(divNova, ele.parentNode.parentNode.firstChild);
                    }
                  }
                  else if (signatureField.contributorIDs.some(cId => currentContributors.indexOf(cId) >= 0)) {
                    //if field is not signed and current user is a contributor that could sign, add it to pdf
                    if (!this.formSubmission.fbFormSignatures.some(s => s.formSignatureFieldID == signatureField.id && !!s.signedDate)) {
                      if (ele.innerHTML.toLowerCase().indexOf('_date') > 0) {
                        const divNova = document.getElementsByTagName('iframe')[0].contentDocument.createElement('div');
                        divNova.innerHTML = `<div style='color: rgba(0,0,0,1);
                                      opacity: 1;z-index: 999999;
                                      border: 0px solid black;
                                      margin-top:2px;
                                      text-align: center;
                                      min-height: 10px;
                                      font-size:10px;
                                      width: 100px;
                                      cursor: pointer;'
                                     id='div${signatureField.signatureName.replace(" ", "")}_date'> 
                                      </div>`;// + moment().format('MM/DD/YYYY') + `
                        if (ele.parentNode.parentNode) {
                          ele.parentNode.parentNode.insertBefore(divNova, ele.parentNode.parentNode.firstChild);
                          ele.parentNode.parentNode.removeChild(ele.parentNode);
                        }

                      }
                      else {
                        const signatureFieldName = signatureField.signatureName;
                        let isSigned = that.signedFields.indexOf(signatureFieldName) >= 0;
                        const isRequired = false;// (ele.innerHTML.toLowerCase().indexOf('optional') < 0) && !(this.optionalFields.indexOf(signatureFieldName) >= 0);

                        const divNova = document.getElementsByTagName('iframe')[0].contentDocument.createElement('div');
                        divNova.innerHTML = `<div style='color: rgba(0,0,0,1);
                                  opacity: 1;z-index: 999999;
                                  border: 1px solid black;
                                  background-color: `
                          + (isSigned ? 'rgba(66, 245, 66, 1)' : (isRequired ? 'rgba(245, 66, 66,1)' : 'rgba(245, 221, 66,1)')) + `;
                                  text-align: center;
                                  width: ` + ((ele.innerHTML.toLowerCase().indexOf('<h1>signature') === 0 || ele.innerHTML.toLowerCase().indexOf('<h1>#signature#') === 0) ? '100' : '34') + `px;
                                  min-height: 10px;
                                  font-size:10px;
                                  cursor: pointer;
                                  '
                                  title='` + (isSigned ? 'signed' : (isRequired ? 'Required Signature' : 'Optional Signature')) + `'
                                  id='div${signatureFieldName.replace(" ", "")}'
                                  > ` + (isSigned ? 'Signed' : 'Sign') + `
                                  </div>`;
                        divNova.onclick = (e) => {
                          (e.target as any).style.backgroundColor =
                            (isSigned ? (isRequired ? 'rgba(245, 66, 66,1)' : 'rgba(245, 221, 66,1)') : 'rgba(66, 245, 66, 1)');
                          (e.target as any).innerHTML = isSigned ? 'Sign' : 'Signed';
                          const target = e.target as HTMLElement;
                          const dateElement = target.id ? document.getElementsByTagName('iframe')[0].contentDocument.getElementById(`${target.id}_date`) : null;

                          if (isSigned) {
                            that.signedFields.splice(that.signedFields.indexOf(signatureFieldName), 1);
                            if (dateElement)
                              dateElement.innerHTML = '';
                          } else {
                            that.signedFields.push(signatureFieldName);
                            if (dateElement)
                              dateElement.innerHTML = moment().format('MM/DD/YYYY');
                          }
                          isSigned = !isSigned;
                        };
                        if (ele.parentNode.parentElement)
                          ele.parentNode.parentNode.insertBefore(divNova, ele.parentNode.parentNode.firstChild);
                      }
                    }
                  }

                  if (this.formSubmission.fbForm.formSignatures.some(fs => ele.innerHTML.indexOf(fs.signatureName) >= 0) && ele.parentNode.parentElement)
                      ele.parentNode.parentElement.removeChild(ele.parentNode);
                }
              }
            }
          }
        }
      }
    }
  }

  extractUserID(field: string) {
    if (field.indexOf('UserID#') < 0) {
      return null;
    }
    const userIdStart = field.indexOf('UserID#') + 7;
    const userIdEnd = field.lastIndexOf('#');

    const userIdString = field.substr(userIdStart, userIdEnd - userIdStart);
    return userIdString;
  }

  setFormSubmission(formSubmission: FBFormSubmissionModel) {
    this.formSubmission = formSubmission;
  }
}
